// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400&family=Inter:wght@700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination button, .pagination div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.interface_heading_row {
  display: flex;
  align-items: center;
}

.interface_noResults {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.interface {
  display: flex;
  flex-direction: column;
}

a {
  text-decoration: none;
}

.link {
  cursor: pointer;
  color: #5c69f9;
}
.link:hover {
  text-decoration: underline;
}

.text-gradient-intel {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-xs {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.text-sm, .interface_heading, .interface_footer {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.text-base {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.text-lg {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .text-lg {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.text-xl {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .text-xl {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.text-leading {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .text-leading {
    line-height: 1.5rem;
  }
}

.breadcumb {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--color-gray-400);
}
.breadcumb a,
.breadcumb span {
  padding: 3px 5px;
}
.breadcumb a {
  text-decoration: none;
  transition: color 0.3s;
  border-radius: 5px;
}
.breadcumb a:hover {
  color: var(--color-primary-500);
  background-color: var(--color-gray-800);
}
.breadcumb .divider {
  color: var(--color-gray-400);
}

.badge {
  width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.badge.xs {
  padding: 3px 5px;
  font-size: 12px;
}
.badge.sm {
  padding: 4px 7px;
}
.badge.primary {
  background: var(--color-primary-500);
}
.badge.primary, .badge.pm {
  background: var(--color-primary-500);
}
.badge.sd {
  background-color: var(--color-secundary-500);
}
.badge.Likely {
  background: var(--color-yellowdark-500);
  color: var(--color-yellowlight-300);
}
.badge.Unvalidated {
  background: var(--color-reddark-500);
  color: var(--color-redlight-300);
}
.badge.Verified, .badge.green {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.badge.off {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.badgeTable {
  width: max-content;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.badgeTable.xs {
  padding: 3px 5px;
  font-size: 12px;
}
.badgeTable.sm {
  padding: 4px 7px;
}
.badgeTable.primary, .badgeTable.pm {
  background: var(--color-primary-500);
}
.badgeTable.sd {
  background-color: var(--color-secundary-500);
}
.badgeTable.Likely {
  background: #413e1a;
  color: #e6f979;
}
.badgeTable.Verified, .badgeTable.green {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.badgeTable.off {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.table.style-1 td,
.table.style-1 th {
  padding: 12px 1rem;
  font-size: 0.875rem;
}
.table.style-1 th,
.table.style-1 td.label {
  color: var(--color-white-500);
}
.table.style-1 th {
  font-weight: normal;
  border-style: solid;
  border-color: var(--color-gray-100);
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.table.style-1 tr.noBorder td {
  border-bottom: none;
}
.table.style-1 tr td {
  color: var(--color-white-500);
}

.pagination {
  display: inline-flex;
  height: 38px;
  border: 1px solid var(--color-gray-700);
  border-radius: 8px;
  width: max-content;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none;
}
.pagination button {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.pagination button:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.pagination button:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .pagination button {
    padding: 0 13px;
    font-size: 14px;
  }
}
.pagination button.disabled, .pagination button.active, .pagination button.info {
  cursor: pointer;
  pointer-events: none;
}
.pagination button.disabled {
  color: var(--color-gray-700);
}
.pagination div {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.pagination div:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.pagination div:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.pagination div:hover, .pagination div.active {
  cursor: pointer;
  background: linear-gradient(var(--color-paper-400), rgba(0, 0, 0, 0.9)) top/100% 500%;
}
@media only screen and (max-width: 450px) {
  .pagination div {
    padding: 0 13px;
    font-size: 14px;
  }
}
.pagination div.disabled, .pagination div.active, .pagination div.info {
  cursor: pointer;
  pointer-events: none;
}
.pagination div.disabled {
  color: var(--color-gray-700);
}
.pagination div:last-child, .pagination div:first-child {
  padding: 0 10px;
}
.pagination div:last-child {
  border-right: none;
}
.pagination button:last-child, .pagination button:first-child {
  padding: 0 10px;
}
.pagination button:last-child {
  border-right: none;
}

.interface {
  width: 100%;
  border-radius: 10px;
  border-left: 2px solid var(--color-gray-800);
  border-right: 2px solid var(--color-gray-800);
  background-color: var(--color-gray-100);
  box-shadow: 0px 2px 11px 0px rgba(255, 255, 255, 0.1);
}
.interface_heading {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px 8px 0 0;
}
@media only screen and (max-width: 450px) {
  .interface_heading {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .interface_heading > div {
    width: 100%;
  }
}
.interface_heading_row {
  justify-content: space-between;
  width: 100%;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .interface_heading_row {
    flex-direction: column;
    align-items: flex-start;
  }
}
.interface_footer {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 0 0 8px 8px;
}
@media only screen and (max-width: 450px) {
  .interface_footer {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .interface_footer > div {
    width: 100%;
  }
}
.interface_foot {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .interface_foot {
    flex-direction: column;
    align-items: flex-start;
  }
}
.interface_noResults {
  gap: 15px;
  padding: 70px 0;
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/* ! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: var(--color-gray-200); /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: var(--color-gray-400); /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

body {
    --color-secundary-500: #1e7f9a;
  }

body[data-theme=default] {
    --color-primary-300: #b07cfc;
    --color-primary-400: #9964fd;
    --color-primary-500: #813efb;
    --color-primary-600: #261f34;
    --color-primary-700: #30224a;
    --color-paper-300: var(--color-gray-500);
    --color-paper-400: var(--color-gray-800);
    --color-paper-500: var(--color-gray-900);
    --color-paper-600: var(--color-gray-900);
    --color-paper-700: var(--color-gray-950);
    --color-greendark-500: #203e40;
    --color-yellowdark-500: #282c1e;
    --color-reddark-500: #2e1423;
    --color-greenlight-300: #4ff3d2;
    --color-yellowlight-300: #e6f979;
    --color-redlight-300: #fa568e;
    --color-white-500: #f2f2f2;
    --color-gray-100: #272239;
    --color-gray-200: #c4bddc;
    --color-gray-300: #a59dc4;
    --color-gray-400: #867dac;
    --color-gray-500: #685f91;
    --color-gray-600: #4e456f;
    --color-gray-700: #272239;
    --color-gray-800: #0a0810;
    --color-gray-900: #06050a;
    --color-gray-950: #06050a80;
    --color-muted: #a197b1;
  }

body[data-theme=qualigence] {
    --color-primary-300: #2164c7;
    --color-primary-400: #3a81e0;
    --color-primary-500: #1d5dbf;
    --color-primary-600: #71a9f9;
    --color-primary-700: #1d5ebf3f;
    --color-paper-300: var(--color-gray-500);
    --color-paper-400: var(--color-gray-800);
    --color-paper-500: var(--color-gray-900);
    --color-paper-600: var(--color-gray-900);
    --color-paper-700: var(--color-gray-950);
    --color-greendark-500: #4ff3d281;
    --color-yellowdark-500: #e6f9797e;
    --color-reddark-500: #fa568d8c;
    --color-greenlight-300: #359784;
    --color-yellowlight-300: #818f31;
    --color-redlight-300: #ad325b;
    --color-green-300: #04bd87;
    --color-white-500: #081534;
    --color-gray-100: #c1d6ea;
    --color-gray-200: #99b7d4;
    --color-gray-300: #5e7f9d;
    --color-gray-400: #0f1b2d;
    --color-gray-500: #264666;
    --color-gray-600: #3b5c7a;
    --color-gray-700: #c4d6e8;
    --color-gray-800: #edf3ff;
    --color-gray-900: #e1effa;
    --color-gray-950: #0f1b2d80;
    --color-muted: #081534;
  }
.\\!container{
  width: 100% !important;
  margin-right: auto !important;
  margin-left: auto !important;
  padding-right: 1.2rem !important;
  padding-left: 1.2rem !important;
}
.container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1.2rem;
  padding-left: 1.2rem;
}
@media (min-width: 480px){
  .\\!container{
    max-width: 480px !important;
  }
  .container{
    max-width: 480px;
  }
}
@media (min-width: 640px){
  .\\!container{
    max-width: 640px !important;
  }
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .\\!container{
    max-width: 768px !important;
  }
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .\\!container{
    max-width: 1024px !important;
  }
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .\\!container{
    max-width: 1280px !important;
  }
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1620px){
  .\\!container{
    max-width: 1620px !important;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .container{
    max-width: 1620px;
    padding-right: 0;
    padding-left: 0;
  }
}
.pointer-events-none{
  pointer-events: none;
}
.visible{
  visibility: visible;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.-left-0{
  left: -0px;
}
.-left-\\[160px\\]{
  left: -160px;
}
.-left-\\[229px\\]{
  left: -229px;
}
.-right-4{
  right: -1rem;
}
.-top-\\[1px\\]{
  top: -1px;
}
.left-\\[70px\\]{
  left: 70px;
}
.right-12{
  right: 3rem;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-16{
  top: 4rem;
}
.top-\\[54px\\]{
  top: 54px;
}
.\\!z-\\[9999999999\\]{
  z-index: 9999999999 !important;
}
.z-10{
  z-index: 10;
}
.z-50{
  z-index: 50;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-10{
  grid-column: span 10 / span 10;
}
.col-span-11{
  grid-column: span 11 / span 11;
}
.col-span-12{
  grid-column: span 12 / span 12;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-6{
  grid-column: span 6 / span 6;
}
.col-span-9{
  grid-column: span 9 / span 9;
}
.col-start-10{
  grid-column-start: 10;
}
.col-start-6{
  grid-column-start: 6;
}
.row-span-10{
  grid-row: span 10 / span 10;
}
.row-span-12{
  grid-row: span 12 / span 12;
}
.row-span-2{
  grid-row: span 2 / span 2;
}
.row-span-3{
  grid-row: span 3 / span 3;
}
.row-span-6{
  grid-row: span 6 / span 6;
}
.row-start-1{
  grid-row-start: 1;
}
.row-start-2{
  grid-row-start: 2;
}
.float-right{
  float: right;
}
.m-auto{
  margin: auto;
}
.\\!mx-auto{
  margin-left: auto !important;
  margin-right: auto !important;
}
.mx-8{
  margin-left: 2rem;
  margin-right: 2rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.\\!ml-0{
  margin-left: 0px !important;
}
.\\!ml-8{
  margin-left: 2rem !important;
}
.-ml-8{
  margin-left: -2rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-\\[14px\\]{
  margin-bottom: 14px;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-\\[12px\\]{
  margin-left: 12px;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-\\[5px\\]{
  margin-right: 5px;
}
.mr-auto{
  margin-right: auto;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.mt-px{
  margin-top: 1px;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-4{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.line-clamp-5{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.\\!flex{
  display: flex !important;
}
.flex{
  display: flex;
}
.\\!table{
  display: table !important;
}
.table{
  display: table;
}
.table-cell{
  display: table-cell;
}
.grid{
  display: grid;
}
.inline-grid{
  display: inline-grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.\\!h-10{
  height: 2.5rem !important;
}
.\\!h-8{
  height: 2rem !important;
}
.\\!h-9{
  height: 2.25rem !important;
}
.\\!h-\\[35px\\]{
  height: 35px !important;
}
.\\!h-\\[40px\\]{
  height: 40px !important;
}
.\\!h-\\[70px\\]{
  height: 70px !important;
}
.\\!h-full{
  height: 100% !important;
}
.h-0{
  height: 0px;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-2{
  height: 0.5rem;
}
.h-28{
  height: 7rem;
}
.h-32{
  height: 8rem;
}
.h-5{
  height: 1.25rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[38px\\]{
  height: 38px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[45px\\]{
  height: 45px;
}
.h-\\[52px\\]{
  height: 52px;
}
.h-\\[58px\\]{
  height: 58px;
}
.h-\\[59px\\]{
  height: 59px;
}
.h-\\[73px\\]{
  height: 73px;
}
.h-\\[76vh\\]{
  height: 76vh;
}
.h-auto{
  height: auto;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.\\!max-h-\\[120px\\]{
  max-height: 120px !important;
}
.\\!max-h-\\[32px\\]{
  max-height: 32px !important;
}
.\\!max-h-\\[40px\\]{
  max-height: 40px !important;
}
.\\!max-h-\\[59px\\]{
  max-height: 59px !important;
}
.max-h-0{
  max-height: 0px;
}
.max-h-12{
  max-height: 3rem;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-8{
  max-height: 2rem;
}
.max-h-9{
  max-height: 2.25rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[10000px\\]{
  max-height: 10000px;
}
.max-h-\\[118px\\]{
  max-height: 118px;
}
.max-h-\\[120px\\]{
  max-height: 120px;
}
.max-h-\\[16px\\]{
  max-height: 16px;
}
.max-h-\\[20px\\]{
  max-height: 20px;
}
.max-h-\\[24px\\]{
  max-height: 24px;
}
.max-h-\\[27\\.5px\\]{
  max-height: 27.5px;
}
.max-h-\\[32px\\]{
  max-height: 32px;
}
.max-h-\\[400px\\]{
  max-height: 400px;
}
.max-h-\\[40px\\]{
  max-height: 40px;
}
.max-h-\\[4200px\\]{
  max-height: 4200px;
}
.max-h-\\[48px\\]{
  max-height: 48px;
}
.max-h-\\[59px\\]{
  max-height: 59px;
}
.max-h-\\[600px\\]{
  max-height: 600px;
}
.max-h-\\[73px\\]{
  max-height: 73px;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[calc\\(100vh-54px\\)\\]{
  max-height: calc(100vh - 54px);
}
.max-h-fit{
  max-height: fit-content;
}
.min-h-12{
  min-height: 3rem;
}
.min-h-8{
  min-height: 2rem;
}
.min-h-\\[350px\\]{
  min-height: 350px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[45px\\]{
  min-height: 45px;
}
.min-h-\\[700px\\]{
  min-height: 700px;
}
.min-h-\\[70px\\]{
  min-height: 70px;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.\\!w-7{
  width: 1.75rem !important;
}
.w-1{
  width: 0.25rem;
}
.w-1\\/4{
  width: 25%;
}
.w-1\\/5{
  width: 20%;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-2\\/4{
  width: 50%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3\\/6{
  width: 50%;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-48{
  width: 12rem;
}
.w-56{
  width: 14rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-9\\/12{
  width: 75%;
}
.w-\\[110px\\]{
  width: 110px;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[140px\\]{
  width: 140px;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[237px\\]{
  width: 237px;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[28px\\]{
  width: 28px;
}
.w-\\[40px\\]{
  width: 40px;
}
.w-\\[45px\\]{
  width: 45px;
}
.w-\\[58px\\]{
  width: 58px;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.\\!min-w-\\[24px\\]{
  min-width: 24px !important;
}
.\\!min-w-fit{
  min-width: fit-content !important;
}
.min-w-20{
  min-width: 5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-\\[1100px\\]{
  min-width: 1100px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[237px\\]{
  min-width: 237px;
}
.min-w-\\[24px\\]{
  min-width: 24px;
}
.min-w-\\[280px\\]{
  min-width: 280px;
}
.min-w-\\[28px\\]{
  min-width: 28px;
}
.min-w-\\[300px\\]{
  min-width: 300px;
}
.min-w-\\[35px\\]{
  min-width: 35px;
}
.min-w-\\[360px\\]{
  min-width: 360px;
}
.min-w-\\[365px\\]{
  min-width: 365px;
}
.min-w-\\[45px\\]{
  min-width: 45px;
}
.min-w-\\[800px\\]{
  min-width: 800px;
}
.min-w-\\[80px\\]{
  min-width: 80px;
}
.min-w-fit{
  min-width: fit-content;
}
.min-w-full{
  min-width: 100%;
}
.\\!max-w-\\[160px\\]{
  max-width: 160px !important;
}
.\\!max-w-\\[24px\\]{
  max-width: 24px !important;
}
.\\!max-w-fit{
  max-width: fit-content !important;
}
.max-w-11{
  max-width: 2.75rem;
}
.max-w-12{
  max-width: 3rem;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4{
  max-width: 1rem;
}
.max-w-56{
  max-width: 14rem;
}
.max-w-8{
  max-width: 2rem;
}
.max-w-\\[120px\\]{
  max-width: 120px;
}
.max-w-\\[150px\\]{
  max-width: 150px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[16px\\]{
  max-width: 16px;
}
.max-w-\\[1700px\\]{
  max-width: 1700px;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[20px\\]{
  max-width: 20px;
}
.max-w-\\[237px\\]{
  max-width: 237px;
}
.max-w-\\[320px\\]{
  max-width: 320px;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-\\[40px\\]{
  max-width: 40px;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-fit{
  max-width: fit-content;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.flex-1{
  flex: 1 1;
}
.basis-1\\/4{
  flex-basis: 25%;
}
.basis-1\\/5{
  flex-basis: 20%;
}
.table-auto{
  table-layout: auto;
}
.scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-pointer{
  cursor: pointer;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize{
  resize: both;
}
.list-decimal{
  list-style-type: decimal;
}
.list-none{
  list-style-type: none;
}
.grid-flow-col{
  grid-auto-flow: column;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-rows-1{
  grid-template-rows: repeat(1, minmax(0, 1fr));
}
.grid-rows-6{
  grid-template-rows: repeat(6, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.\\!flex-col{
  flex-direction: column !important;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.\\!justify-start{
  justify-content: flex-start !important;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.justify-evenly{
  justify-content: space-evenly;
}
.\\!gap-0{
  gap: 0px !important;
}
.\\!gap-1{
  gap: 0.25rem !important;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-14{
  gap: 3.5rem;
}
.gap-16{
  gap: 4rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[14px\\]{
  gap: 14px;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.divide-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(2px * var(--tw-divide-x-reverse));
  border-left-width: calc(2px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-600 > :not([hidden]) ~ :not([hidden]){
  border-color: var(--color-gray-600);
}
.divide-gray-700 > :not([hidden]) ~ :not([hidden]){
  border-color: var(--color-gray-700);
}
.self-center{
  align-self: center;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-clip{
  overflow: clip;
}
.overflow-scroll{
  overflow: scroll;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.overflow-y-scroll{
  overflow-y: scroll;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.text-nowrap{
  text-wrap: nowrap;
}
.break-words{
  overflow-wrap: break-word;
}
.\\!rounded-\\[8px\\]{
  border-radius: 8px !important;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[12px\\]{
  border-radius: 12px;
}
.rounded-\\[15px\\]{
  border-radius: 15px;
}
.rounded-\\[8px\\]{
  border-radius: 8px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-2xl{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-none{
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-bl-none{
  border-bottom-left-radius: 0px;
}
.rounded-tl-none{
  border-top-left-radius: 0px;
}
.rounded-tr-none{
  border-top-right-radius: 0px;
}
.\\!border{
  border-width: 1px !important;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.\\!border-r{
  border-right-width: 1px !important;
}
.border-b{
  border-bottom-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-0{
  border-left-width: 0px;
}
.border-r{
  border-right-width: 1px;
}
.border-r-0{
  border-right-width: 0px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-0{
  border-top-width: 0px;
}
.border-t-2{
  border-top-width: 2px;
}
.\\!border-solid{
  border-style: solid !important;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.\\!border-none{
  border-style: none !important;
}
.border-none{
  border-style: none;
}
.\\!border-gray-700{
  border-color: var(--color-gray-700) !important;
}
.\\!border-primary-400{
  border-color: var(--color-primary-400) !important;
}
.\\!border-primary-500{
  border-color: var(--color-primary-500) !important;
}
.border-\\[var\\(--color-paper-400\\)\\]{
  border-color: var(--color-paper-400);
}
.border-\\[var\\(--color-paper-600\\)\\]{
  border-color: var(--color-paper-600);
}
.border-gray-300{
  border-color: var(--color-gray-300);
}
.border-gray-600{
  border-color: var(--color-gray-600);
}
.border-gray-700{
  border-color: var(--color-gray-700);
}
.border-gray-800{
  border-color: var(--color-gray-800);
}
.border-gray-900{
  border-color: var(--color-gray-900);
}
.border-paper-400{
  border-color: var(--color-paper-400);
}
.border-primary-300{
  border-color: var(--color-primary-300);
}
.border-primary-500{
  border-color: var(--color-primary-500);
}
.border-transparent{
  border-color: transparent;
}
.border-white-500{
  border-color: var(--color-white-500);
}
.border-t-paper-600{
  border-top-color: var(--color-paper-600);
}
.\\!bg-gray-800{
  background-color: var(--color-gray-800) !important;
}
.\\!bg-paper-400{
  background-color: var(--color-paper-400) !important;
}
.\\!bg-primary-600{
  background-color: var(--color-primary-600) !important;
}
.\\!bg-transparent{
  background-color: transparent !important;
}
.bg-\\[\\#323135\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(50 49 53 / var(--tw-bg-opacity, 1));
}
.bg-\\[var\\(--color-paper-300\\)\\]{
  background-color: var(--color-paper-300);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-gray-100{
  background-color: var(--color-gray-100);
}
.bg-gray-200{
  background-color: var(--color-gray-200);
}
.bg-gray-400{
  background-color: var(--color-gray-400);
}
.bg-gray-500{
  background-color: var(--color-gray-500);
}
.bg-gray-600{
  background-color: var(--color-gray-600);
}
.bg-gray-700{
  background-color: var(--color-gray-700);
}
.bg-gray-800{
  background-color: var(--color-gray-800);
}
.bg-gray-900{
  background-color: var(--color-gray-900);
}
.bg-gray-950{
  background-color: var(--color-gray-950);
}
.bg-greendark-500{
  background-color: var(--color-greendark-500);
}
.bg-paper-400{
  background-color: var(--color-paper-400);
}
.bg-paper-500{
  background-color: var(--color-paper-500);
}
.bg-primary-500{
  background-color: var(--color-primary-500);
}
.bg-primary-600{
  background-color: var(--color-primary-600);
}
.bg-primary-700{
  background-color: var(--color-primary-700);
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-reddark-500{
  background-color: var(--color-reddark-500);
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white-500{
  background-color: var(--color-white-500);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellowdark-500{
  background-color: var(--color-yellowdark-500);
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.from-purple-500\\/40{
  --tw-gradient-from: rgb(168 85 247 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-violet-600\\/20{
  --tw-gradient-to: rgb(124 58 237 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(124 58 237 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-purple-900\\/20{
  --tw-gradient-to: rgb(88 28 135 / 0.2) var(--tw-gradient-to-position);
}
.bg-cover{
  background-size: cover;
}
.bg-center{
  background-position: center;
}
.fill-none{
  fill: none;
}
.stroke-primary-500{
  stroke: var(--color-primary-500);
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-left{
  object-position: left;
}
.\\!p-0{
  padding: 0px !important;
}
.\\!p-2{
  padding: 0.5rem !important;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-16{
  padding: 4rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.\\!px-0{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!px-5{
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-\\[20px\\]{
  padding-left: 20px;
  padding-right: 20px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.\\!pb-0{
  padding-bottom: 0px !important;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-14{
  padding-bottom: 3.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pl-0{
  padding-left: 0px;
}
.pl-1{
  padding-left: 0.25rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-\\[16px\\]{
  padding-left: 16px;
}
.pl-\\[76px\\]{
  padding-left: 76px;
}
.pr-0{
  padding-right: 0px;
}
.pr-0\\.5{
  padding-right: 0.125rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-40{
  padding-top: 10rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.\\!text-left{
  text-align: left !important;
}
.text-left{
  text-align: left;
}
.\\!text-center{
  text-align: center !important;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-justify{
  text-align: justify;
}
.text-start{
  text-align: start;
}
.align-middle{
  vertical-align: middle;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.\\!text-\\[14px\\]{
  font-size: 14px !important;
}
.\\!text-\\[26px\\]{
  font-size: 26px !important;
}
.\\!text-sm{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.\\!text-xs{
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[19px\\]{
  font-size: 19px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-bold{
  font-weight: 700 !important;
}
.\\!font-normal{
  font-weight: 400 !important;
}
.\\!font-semibold{
  font-weight: 600 !important;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-extralight{
  font-weight: 200;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-relaxed{
  line-height: 1.625;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.\\!text-gray-100{
  color: var(--color-gray-100) !important;
}
.\\!text-gray-200{
  color: var(--color-gray-200) !important;
}
.\\!text-gray-400{
  color: var(--color-gray-400) !important;
}
.\\!text-greenlight-300{
  color: var(--color-greenlight-300) !important;
}
.\\!text-primary-300{
  color: var(--color-primary-300) !important;
}
.\\!text-primary-500{
  color: var(--color-primary-500) !important;
}
.\\!text-white-500{
  color: var(--color-white-500) !important;
}
.text-\\[\\#ff92ff\\]{
  --tw-text-opacity: 1;
  color: rgb(255 146 255 / var(--tw-text-opacity, 1));
}
.text-gray-200{
  color: var(--color-gray-200);
}
.text-gray-300{
  color: var(--color-gray-300);
}
.text-gray-400{
  color: var(--color-gray-400);
}
.text-gray-500{
  color: var(--color-gray-500);
}
.text-gray-600{
  color: var(--color-gray-600);
}
.text-gray-700{
  color: var(--color-gray-700);
}
.text-gray-800{
  color: var(--color-gray-800);
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-greenlight-300{
  color: var(--color-greenlight-300);
}
.text-muted{
  color: var(--color-muted);
}
.text-paper-400{
  color: var(--color-paper-400);
}
.text-paper-500{
  color: var(--color-paper-500);
}
.text-primary-300{
  color: var(--color-primary-300);
}
.text-primary-400{
  color: var(--color-primary-400);
}
.text-primary-500{
  color: var(--color-primary-500);
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-redlight-300{
  color: var(--color-redlight-300);
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white-500{
  color: var(--color-white-500);
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-yellowlight-300{
  color: var(--color-yellowlight-300);
}
.underline{
  text-decoration-line: underline;
}
.\\!caret-white-500{
  caret-color: var(--color-white-500) !important;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-80{
  opacity: 0.8;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-gray-600{
  --tw-ring-color: var(--color-gray-600);
}
.ring-gray-700{
  --tw-ring-color: var(--color-gray-700);
}
.ring-gray-800{
  --tw-ring-color: var(--color-gray-800);
}
.ring-primary-500{
  --tw-ring-color: var(--color-primary-500);
}
.ring-primary-600{
  --tw-ring-color: var(--color-primary-600);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-300{
  transition-delay: 300ms;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.range-slider {
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  background: var(--color-gray-300);
  border-radius: 10px;
  outline: none;
}
.range-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 24px;
  width: 24px;
  background: var(--color-primary-500);
  border: 4px solid var(--color-white-500);
  border-radius: 50%;
  cursor: pointer;
  margin-top: -8px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
}
.range-slider::-moz-range-thumb {
  height: 24px;
  width: 24px;
  background: var(--color-primary-500);
  border: 4px solid var(--color-white-500);
  border-radius: 50%;
  cursor: pointer;
}
.range-slider::-webkit-slider-runnable-track {
  height: 8px;
  border-radius: 10px;
}
.range-slider::-moz-range-track {
  height: 8px;
  background: var(--color-gray-300);
  border-radius: 10px;
}

.bg-primary{
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-image: var(--background-image) !important;
}

.recharts-legend-item {
  margin-left: 36px !important;
  margin-right: 0px !important;
}

.lato {
  font-family: "Inter", sans-serif;
}

.react-datepicker__input-container input {
  height: 48px;
  cursor: pointer;
}

.react-datepicker {
  background-color: var(--color-gray-800) !important;
  color: var(--color-white-500) !important;
  border: 1px solid var(--color-primary-400) !important;
  padding: 8px;
}

.react-datepicker__header {
  border: 0 !important;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  background-color: var(--color-gray-800) !important;
  color: var(--color-white-500) !important;
}

.react-datepicker__month-text.react-datepicker__month-1.react-datepicker__month-text--selected.react-datepicker__month-text--keyboard-selected.react-datepicker__month-text--today {
  color: var(--color-white-500) !important;
}

.react-datepicker__month-text react-datepicker__month-1 react-datepicker__month-text--selected react-datepicker__month-text--keyboard-selected react-datepicker__month-text--today {
  padding: 4px;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  background-color: var(--color-primary-400) !important;
}

.react-datepicker__triangle {
  display: none;
}

* {
  outline: none;
  padding: 0;
  margin: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
  /* Handle */
  /* Handle on hover */
  /* Hide arrow buttons */
  /* Hide corner */
}
* h1,
* h2,
* h3,
* h4,
* h5,
* p {
  color: var(--color-white-500);
}
*::-webkit-scrollbar {
  width: 9px;
  height: 10px;
  background-color: var(--color-gray-300);
}
*::-webkit-scrollbar-thumb {
  background: var(--color-gray-200);
  border-radius: 15px;
}
*::-webkit-scrollbar-thumb:hover {
  background: var(--color-white-500);
}
*::-webkit-scrollbar-button {
  display: none;
}
*::-webkit-scrollbar-corner {
  background: transparent;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden !important;
}

body,
html {
  background-color: var(--bg-color);
}

label {
  color: var(--color-white-500);
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: var(--color-gray-800);
}

::-webkit-scrollbar-track {
  background: var(--color-gray-800);
  border-radius: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: var(--color-gray-700);
  border-radius: 8px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-primary-500);
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}

.hover\\:cursor-pointer:hover{
  cursor: pointer;
}

.hover\\:\\!border-primary-500:hover{
  border-color: var(--color-primary-500) !important;
}

.hover\\:border-primary-400:hover{
  border-color: var(--color-primary-400);
}

.hover\\:\\!bg-paper-300:hover{
  background-color: var(--color-paper-300) !important;
}

.hover\\:\\!bg-primary-400:hover{
  background-color: var(--color-primary-400) !important;
}

.hover\\:\\!bg-primary-600:hover{
  background-color: var(--color-primary-600) !important;
}

.hover\\:bg-gray-300:hover{
  background-color: var(--color-gray-300);
}

.hover\\:bg-gray-600:hover{
  background-color: var(--color-gray-600);
}

.hover\\:bg-gray-700:hover{
  background-color: var(--color-gray-700);
}

.hover\\:bg-gray-800:hover{
  background-color: var(--color-gray-800);
}

.hover\\:bg-gray-900:hover{
  background-color: var(--color-gray-900);
}

.hover\\:bg-paper-400:hover{
  background-color: var(--color-paper-400);
}

.hover\\:bg-primary-400:hover{
  background-color: var(--color-primary-400);
}

.hover\\:bg-primary-500:hover{
  background-color: var(--color-primary-500);
}

.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:\\!text-primary-500:hover{
  color: var(--color-primary-500) !important;
}

.hover\\:\\!text-white-500:hover{
  color: var(--color-white-500) !important;
}

.hover\\:text-gray-300:hover{
  color: var(--color-gray-300);
}

.hover\\:text-primary-500:hover{
  color: var(--color-primary-500);
}

.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-white-500:hover{
  color: var(--color-white-500);
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:opacity-70:hover{
  opacity: 0.7;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:ring-gray-800:hover{
  --tw-ring-color: var(--color-gray-800);
}

.group:hover .group-hover\\:flex{
  display: flex;
}

.group:hover .group-hover\\:\\!bg-transparent{
  background-color: transparent !important;
}

.group:hover .group-hover\\:bg-paper-300{
  background-color: var(--color-paper-300);
}

.group:hover .group-hover\\:bg-paper-600{
  background-color: var(--color-paper-600);
}

.group:hover .group-hover\\:\\!text-inherit{
  color: inherit !important;
}

.group:hover .group-hover\\:text-white-500{
  color: var(--color-white-500);
}

.peer:checked ~ .peer-checked\\:cursor-default{
  cursor: default;
}

.peer:checked ~ .peer-checked\\:\\!border-primary-500{
  border-color: var(--color-primary-500) !important;
}

.peer:checked ~ .peer-checked\\:\\!bg-primary-500{
  background-color: var(--color-primary-500) !important;
}

.peer:checked ~ .peer-checked\\:bg-paper-700{
  background-color: var(--color-paper-700);
}

.peer:checked ~ .peer-checked\\:bg-primary-500{
  background-color: var(--color-primary-500);
}

.peer:checked ~ .peer-checked\\:font-semibold{
  font-weight: 600;
}

.peer:checked ~ .peer-checked\\:text-primary-500{
  color: var(--color-primary-500);
}

[data-theme="qualigence"] .qualigence\\:divide-gray-700 > :not([hidden]) ~ :not([hidden]){
  border-color: var(--color-gray-700);
}

[data-theme="qualigence"] .qualigence\\:bg-gray-100{
  background-color: var(--color-gray-100);
}

[data-theme="qualigence"] .qualigence\\:font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

[data-theme="qualigence"] .qualigence\\:text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

[data-theme="qualigence"] .qualigence\\:text-white-500{
  color: var(--color-white-500);
}

[data-theme="qualigence"] .qualigence\\:hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

@media not all and (min-width: 1620px){
  .max-2xl\\:max-w-\\[1320px\\]{
    max-width: 1320px;
  }
}

@media not all and (min-width: 1280px){
  .max-xl\\:max-w-\\[1024px\\]{
    max-width: 1024px;
  }
}

@media not all and (min-width: 1024px){
  .max-lg\\:max-w-\\[810px\\]{
    max-width: 810px;
  }
}

@media not all and (min-width: 768px){
  .max-md\\:max-w-\\[630px\\]{
    max-width: 630px;
  }
  .max-md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media not all and (min-width: 640px){
  .max-sm\\:gap-3{
    gap: 0.75rem;
  }
}

@media (min-width: 640px){
  .sm\\:col-span-12{
    grid-column: span 12 / span 12;
  }
  .sm\\:mt-8{
    margin-top: 2rem;
  }
  .sm\\:block{
    display: block;
  }
  .sm\\:flex{
    display: flex;
  }
  .sm\\:table-cell{
    display: table-cell;
  }
  .sm\\:table-row{
    display: table-row;
  }
  .sm\\:h-screen{
    height: 100vh;
  }
  .sm\\:w-1\\/4{
    width: 25%;
  }
  .sm\\:w-2\\/4{
    width: 50%;
  }
  .sm\\:w-3\\/12{
    width: 25%;
  }
  .sm\\:w-5\\/12{
    width: 41.666667%;
  }
  .sm\\:w-60{
    width: 15rem;
  }
  .sm\\:w-8\\/12{
    width: 66.666667%;
  }
  .sm\\:w-auto{
    width: auto;
  }
  .sm\\:w-max{
    width: max-content;
  }
  .sm\\:basis-4\\/5{
    flex-basis: 80%;
  }
  .sm\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:items-end{
    align-items: flex-end;
  }
  .sm\\:gap-0{
    gap: 0px;
  }
  .sm\\:gap-10{
    gap: 2.5rem;
  }
  .sm\\:gap-2{
    gap: 0.5rem;
  }
  .sm\\:gap-3{
    gap: 0.75rem;
  }
  .sm\\:gap-4{
    gap: 1rem;
  }
  .sm\\:gap-6{
    gap: 1.5rem;
  }
  .sm\\:gap-7{
    gap: 1.75rem;
  }
  .sm\\:gap-9{
    gap: 2.25rem;
  }
  .sm\\:border-none{
    border-style: none;
  }
  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .sm\\:pb-\\[150px\\]{
    padding-bottom: 150px;
  }
  .sm\\:pt-48{
    padding-top: 12rem;
  }
}

@media (min-width: 768px){
  .md\\:absolute{
    position: absolute;
  }
  .md\\:relative{
    position: relative;
  }
  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }
  .md\\:col-span-8{
    grid-column: span 8 / span 8;
  }
  .md\\:mb-0{
    margin-bottom: 0px;
  }
  .md\\:block{
    display: block;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:grid{
    display: grid;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:h-12{
    height: 3rem;
  }
  .md\\:max-h-full{
    max-height: 100%;
  }
  .md\\:min-h-\\[74vh\\]{
    min-height: 74vh;
  }
  .md\\:min-h-screen{
    min-height: 100vh;
  }
  .md\\:w-fit{
    width: fit-content;
  }
  .md\\:max-w-\\[550px\\]{
    max-width: 550px;
  }
  .md\\:table-fixed{
    table-layout: fixed;
  }
  .md\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
  .md\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:gap-0{
    gap: 0px;
  }
  .md\\:gap-0\\.5{
    gap: 0.125rem;
  }
  .md\\:whitespace-nowrap{
    white-space: nowrap;
  }
  .md\\:p-2{
    padding: 0.5rem;
  }
  .md\\:p-4{
    padding: 1rem;
  }
  .md\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .md\\:px-40{
    padding-left: 10rem;
    padding-right: 10rem;
  }
  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .md\\:pb-0{
    padding-bottom: 0px;
  }
  .md\\:pl-\\[16px\\]{
    padding-left: 16px;
  }
  .md\\:pl-\\[50px\\]{
    padding-left: 50px;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px){
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:overflow-x-hidden{
    overflow-x: hidden;
  }
}

.\\[\\&_\\.ant-tabs-nav\\:\\:before\\]\\:\\!border-b-\\[var\\(--color-gray-700\\)\\] .ant-tabs-nav::before{
  border-bottom-color: var(--color-gray-700) !important;
}

.\\[\\&_\\.ant-tabs-nav\\]\\:\\!border-b-\\[var\\(--color-gray-700\\)\\] .ant-tabs-nav{
  border-bottom-color: var(--color-gray-700) !important;
}

.\\[\\&_\\.ant-tabs-tab-active\\]\\:\\!bg-\\[var\\(--color-primary-700\\)\\] .ant-tabs-tab-active{
  background-color: var(--color-primary-700) !important;
}

.\\[\\&_\\.ant-tabs-tab-active\\]\\:\\!font-semibold .ant-tabs-tab-active{
  font-weight: 600 !important;
}

.\\[\\&_\\.ant-tabs-tab-active_\\.ant-tabs-tab-btn\\]\\:\\!text-\\[var\\(--color-white-500\\)\\] .ant-tabs-tab-active .ant-tabs-tab-btn{
  color: var(--color-white-500) !important;
}

.\\[\\&_\\.ant-tabs-tab-btn\\]\\:\\!font-semibold .ant-tabs-tab-btn{
  font-weight: 600 !important;
}

.\\[\\&_\\.ant-tabs-tab-btn\\]\\:\\!text-\\[var\\(--color-white-500\\)\\] .ant-tabs-tab-btn{
  color: var(--color-white-500) !important;
}

.\\[\\&_\\.ant-tabs-tab\\:hover_\\.ant-tabs-tab-btn\\]\\:\\!text-\\[var\\(--color-primary-500\\)\\] .ant-tabs-tab:hover .ant-tabs-tab-btn{
  color: var(--color-primary-500) !important;
}

.\\[\\&_\\.ant-tabs-tab\\]\\:\\!rounded-t-md .ant-tabs-tab{
  border-top-left-radius: 0.375rem !important;
  border-top-right-radius: 0.375rem !important;
}

.\\[\\&_\\.ant-tabs-tab\\]\\:\\!border-\\[1px\\] .ant-tabs-tab{
  border-width: 1px !important;
}

.\\[\\&_\\.ant-tabs-tab\\]\\:\\!border-\\[var\\(--color-gray-700\\)\\] .ant-tabs-tab{
  border-color: var(--color-gray-700) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_flex.scss","webpack://./src/App.scss","webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/assets/scss/_breakpoint.scss","webpack://./src/assets/scss/theme/_breadcumb.scss","webpack://./src/assets/scss/theme/_badge.scss","webpack://./src/assets/scss/theme/_table.scss","webpack://./src/assets/scss/theme/_pagination.scss","webpack://./src/assets/scss/theme/_global.scss","webpack://./src/assets/scss/theme/_interface.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ACEF;;ADCA;EACE,aAAA;EACA,mBAAA;ACEF;;ADYA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ACTF;;AD4BA;EACE,aAAA;EACA,sBAAA;ACzBF;;ACdA;EACI,qBAAA;ADiBJ;;ACfA;EACI,eAAA;EACA,cAAA;ADkBJ;ACjBI;EACE,0BAAA;ADmBN;;ACfA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;ADkBJ;;ACfI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;ADkBR;AChBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;ADkBR;AChBI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;ADkBR;AChBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ADkBR;AE1DE;EDsCE;IAIQ,eAAA;IACA,mBAAA;EDoBV;AACF;AClBI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ADoBR;AEpEE;ED8CE;IAIQ,eAAA;IACA,mBAAA;EDsBV;AACF;ACpBI;EACI,mBAAA;ADsBR;AE7EE;EDsDE;IAGQ,mBAAA;EDwBV;AACF;;AGhFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;AHmFF;AGlFE;;EAEE,gBAAA;AHoFJ;AGlFE;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AHoFJ;AGnFI;EACE,+BAAA;EACA,uCAAA;AHqFN;AGlFE;EACE,4BAAA;AHoFJ;;AIxGA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJ2GF;AIxGE;EACE,gBAAA;EACA,eAAA;AJ0GJ;AIxGE;EACE,gBAAA;AJ0GJ;AItGE;EACE,oCAAA;AJwGJ;AItGE;EAEE,oCAAA;AJuGJ;AIrGE;EACE,4CAAA;AJuGJ;AIrGE;EACE,uCAAA;EACA,mCAAA;AJuGJ;AIrGE;EACE,oCAAA;EACA,gCAAA;AJuGJ;AIrGE;EAEE,4CAAA;EACA,kCAAA;AJsGJ;AIpGE;EACE,6BAAA;EACA,uCAAA;AJsGJ;;AInGA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJsGF;AInGE;EACE,gBAAA;EACA,eAAA;AJqGJ;AInGE;EACE,gBAAA;AJqGJ;AIjGE;EAEE,oCAAA;AJkGJ;AIhGE;EACE,4CAAA;AJkGJ;AIhGE;EACE,mBAAA;EACA,cAAA;AJkGJ;AIhGE;EAEE,4CAAA;EACA,kCAAA;AJiGJ;AI/FE;EACE,6BAAA;EACA,uCAAA;AJiGJ;;AKzLA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;AL4LF;AK1LI;;EAEE,kBAAA;EACA,mBAAA;AL4LN;AK1LI;;EAEE,6BAAA;AL4LN;AK1LI;EACE,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,qBAAA;EACA,wBAAA;AL4LN;AKzLM;EACE,mBAAA;AL2LR;AKzLM;EACE,6BAAA;AL2LR;;AM/MA;EACI,oBAAA;EACA,YAAA;EAEA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA;ANiNJ;AM/MI;ELbA,wDAAA;EKgBI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;ANgNR;AM/MQ;EACI,2BAAA;EACA,8BAAA;ANiNZ;AM/MQ;EACI,4BAAA;EACA,+BAAA;ANiNZ;AEhPE;EIgBE;IAkBQ,eAAA;IACA,eAAA;ENkNV;AACF;AMjNQ;EACI,eAAA;EACA,oBAAA;ANmNZ;AMjNQ;EACI,4BAAA;ANmNZ;AMhNI;EL1CA,wDAAA;EK6CI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;ANiNR;AMhNQ;EACI,2BAAA;EACA,8BAAA;ANkNZ;AMhNQ;EACI,4BAAA;EACA,+BAAA;ANkNZ;AMhNQ;ECrCJ,eAAA;EACA,qFAAA;APwPJ;AElRE;EI6CE;IAqBQ,eAAA;IACA,eAAA;ENoNV;AACF;AMnNQ;EACI,eAAA;EACA,oBAAA;ANqNZ;AMnNQ;EACI,4BAAA;ANqNZ;AMlNI;EACI,eAAA;ANoNR;AMlNI;EACI,kBAAA;ANoNR;AMlNI;EACI,eAAA;ANoNR;AMlNI;EACI,kBAAA;ANoNR;;AQtSA;EACE,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,6CAAA;EACA,uCAAA;EAGA,qDAAA;ARySF;AQvSE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;ARwSJ;AEhUE;EMeA;IAWI,kBAAA;IACA,uBAAA;ER0SJ;EQzSI;IACE,WAAA;ER2SN;AACF;AQzSI;EAEE,8BAAA;EACA,WAAA;EACA,SAAA;AR0SN;AE9UE;EMgCE;IAMI,sBAAA;IACA,uBAAA;ER4SN;AACF;AQzSE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;AR0SJ;AE9VE;EM2CA;IAWI,kBAAA;IACA,uBAAA;ER4SJ;EQ3SI;IACE,WAAA;ER6SN;AACF;AQ1SE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AR4SJ;AE5WE;EM6DA;IAKI,sBAAA;IACA,uBAAA;ER8SJ;AACF;AQ5SE;EAEE,SAAA;EACA,eAAA;AR6SJ;;AArXA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA,kEAAA;;AAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,mCAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,4BAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;IAAA,8BAAA;EAAA;;AAAA;IAAA,4BAAA;IAAA,4BAAA;IAAA,4BAAA;IAAA,4BAAA;IAAA,4BAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,8BAAA;IAAA,+BAAA;IAAA,4BAAA;IAAA,+BAAA;IAAA,gCAAA;IAAA,6BAAA;IAAA,0BAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,2BAAA;IAAA,sBAAA;EAAA;;AAAA;IAAA,4BAAA;IAAA,4BAAA;IAAA,4BAAA;IAAA,4BAAA;IAAA,8BAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,gCAAA;IAAA,iCAAA;IAAA,8BAAA;IAAA,+BAAA;IAAA,gCAAA;IAAA,6BAAA;IAAA,0BAAA;IAAA,0BAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,yBAAA;IAAA,2BAAA;IAAA,sBAAA;EAAA;AACA;EAAA,sBAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,WAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA,4BAAA;IAAA,2BAAA;IAAA;EAAA;EAAA;IAAA,iBAAA;IAAA,gBAAA;IAAA;EAAA;AAAA;AACA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,0DAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wJAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAkFA;EACE,wBAAA;EACA,WAAA;EACA,WAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;AAyWF;AAvWE;EACE,wBAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;AAyWJ;AAtWE;EACE,YAAA;EACA,WAAA;EACA,oCAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;AAwWJ;AArWE;EACE,WAAA;EACA,mBAAA;AAuWJ;AAnWE;EACE,WAAA;EACA,iCAAA;EACA,mBAAA;AAqWJ;;AAhWE;EAAA,iBAAA;EAAA,sBAAA;EAAA,2BAAA;EACA;AADA;;AAIF;EACE,4BAAA;EACA,4BAAA;AAoWF;;AAjWA;EACE,gCAAA;AAoWF;;AAhWE;EACE,YAAA;EACA,eAAA;AAmWJ;;AA/VA;EACE,kDAAA;EACA,wCAAA;EACA,qDAAA;EACA,YAAA;AAkWF;;AA/VA;EACE,oBAAA;AAkWF;;AA/VA;;;EAGE,kDAAA;EACA,wCAAA;AAkWF;;AA/VA;EACE,wCAAA;AAkWF;;AA/VA;EAKE,YAAA;AA8VF;;AA3VA;;;;EAIE,qDAAA;AA8VF;;AA3VA;EACE,aAAA;AA8VF;;AA3VA;EACE,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;EAiBA,WAAA;EAMA,oBAAA;EAKA,uBAAA;EAKA,gBAAA;AAiUF;AAhWE;;;;;;EAME,6BAAA;AAkWJ;AA/VE;EACE,UAAA;EACA,YAAA;EACA,uCAAA;AAiWJ;AA7VE;EACE,iCAAA;EACA,mBAAA;AA+VJ;AA3VE;EACE,kCAAA;AA6VJ;AAzVE;EACE,aAAA;AA2VJ;AAvVE;EACE,uBAAA;AAyVJ;;AArVA;EAEE,mCAAA;EACA,kCAAA;EACA,6BAAA;AAuVF;;AApVA;;EAEE,iCAAA;AAuVF;;AApVA;EACE,6BAAA;AAuVF;;AApVA;EACE,UAAA;EACA,WAAA;EACA,uCAAA;AAuVF;;AApVA;EACE,iCAAA;EACA,kBAAA;AAuVF;;AApVA;EACE,uCAAA;EACA,kBAAA;AAuVF;;AApVA;EACE,oCAAA;AAuVF;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA,kBAmmBR;EAnmBQ;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA,oBAmmBR;EAnmBQ;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA,oBAmmBR;EAnmBQ;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA,oBAmmBR;EAnmBQ;AAmmBR;;AAnmBQ;EAAA;IAAA;EAmmBR;AAAA;;AAnmBQ;EAAA;IAAA;EAmmBR;AAAA;;AAnmBQ;EAAA;IAAA;EAmmBR;AAAA;;AAnmBQ;EAAA;IAAA;EAmmBR;EAnmBQ;IAAA,kBAmmBR;IAnmBQ;EAmmBR;AAAA;;AAnmBQ;EAAA;IAAA;EAmmBR;AAAA;;AAnmBQ;EAAA;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA,qBAmmBR;IAnmBQ;EAmmBR;EAnmBQ;IAAA,oBAmmBR;IAnmBQ;EAmmBR;EAnmBQ;IAAA,iBAmmBR;IAnmBQ;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;AAAA;;AAnmBQ;EAAA;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA,oBAmmBR;IAnmBQ;EAmmBR;EAnmBQ;IAAA,kBAmmBR;IAnmBQ;EAmmBR;EAnmBQ;IAAA,mBAmmBR;IAnmBQ;EAmmBR;EAnmBQ;IAAA,kBAmmBR;IAnmBQ;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;EAnmBQ;IAAA,eAmmBR;IAnmBQ;EAmmBR;EAnmBQ;IAAA,mBAmmBR;IAnmBQ;EAmmBR;AAAA;;AAnmBQ;EAAA;IAAA;EAmmBR;EAnmBQ;IAAA;EAmmBR;AAAA;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA,2CAmmBR;EAnmBQ;AAmmBR;;AAnmBQ;EAAA;AAmmBR;;AAnmBQ;EAAA;AAmmBR","sourcesContent":["%flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-align {\n  display: flex;\n  align-items: center;\n}\n\n%flex-stretch {\n  display: flex;\n  align-items: stretch;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n%flex-column-align {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n%flex-justify-center {\n  display: flex;\n  justify-content: center;\n}\n\n%flex-justify-between-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%flex-justify-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n%flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n%flex-column-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-center-reverse {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n%flex-align-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n%flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n%flex-column-align-start {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n%flex-justify-evenly {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n%flex-justify-evenly-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}","@use \"./assets/scss/\" as *;\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400&family=Inter:wght@700&display=swap\");\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  body {\n    --color-secundary-500: #1e7f9a;\n  }\n\n  body[data-theme=\"default\"] {\n    --color-primary-300: #b07cfc;\n    --color-primary-400: #9964fd;\n    --color-primary-500: #813efb;\n    --color-primary-600: #261f34;\n    --color-primary-700: #30224a;\n\n    --color-paper-300: var(--color-gray-500);\n    --color-paper-400: var(--color-gray-800);\n    --color-paper-500: var(--color-gray-900);\n    --color-paper-600: var(--color-gray-900);\n    --color-paper-700: var(--color-gray-950);\n\n    --color-greendark-500: #203e40;\n    --color-yellowdark-500: #282c1e;\n    --color-reddark-500: #2e1423;\n\n    --color-greenlight-300: #4ff3d2;\n    --color-yellowlight-300: #e6f979;\n    --color-redlight-300: #fa568e;\n\n    --color-white-500: #f2f2f2;\n\n    --color-gray-100: #272239;\n    --color-gray-200: #c4bddc;\n    --color-gray-300: #a59dc4;\n    --color-gray-400: #867dac;\n    --color-gray-500: #685f91;\n    --color-gray-600: #4e456f;\n    --color-gray-700: #272239; //used to borders\n    --color-gray-800: #0a0810; //used for cards background\n    --color-gray-900: #06050a;\n    --color-gray-950: #06050a80;\n    --color-muted: #a197b1;\n  }\n\n  body[data-theme=\"qualigence\"] {\n    --color-primary-300: #2164c7;\n    --color-primary-400: #3a81e0;\n    --color-primary-500: #1d5dbf;\n    --color-primary-600: #71a9f9;\n    --color-primary-700: #1d5ebf3f;\n\n    --color-paper-300: var(--color-gray-500);\n    --color-paper-400: var(--color-gray-800);\n    --color-paper-500: var(--color-gray-900);\n    --color-paper-600: var(--color-gray-900);\n    --color-paper-700: var(--color-gray-950);\n\n    --color-greendark-500: #4ff3d281;\n    --color-yellowdark-500: #e6f9797e;\n    --color-reddark-500: #fa568d8c;\n\n    --color-greenlight-300: #359784;\n    --color-yellowlight-300: #818f31;\n    --color-redlight-300: #ad325b;\n\n    --color-green-300: #04bd87;\n\n    --color-white-500: #081534;\n\n    --color-gray-100: #c1d6ea;\n    --color-gray-200: #99b7d4;\n    --color-gray-300: #5e7f9d;\n    --color-gray-400: #0f1b2d;\n    --color-gray-500: #264666;\n    --color-gray-600: #3b5c7a;\n    --color-gray-700: #c4d6e8; //used to borders\n    --color-gray-800: #edf3ff; //used for cards background\n    --color-gray-900: #e1effa;\n    --color-gray-950: #0f1b2d80;\n    --color-muted: #081534;\n  }\n}\n\n.range-slider {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 8px;\n  background: var(--color-gray-300);\n  border-radius: 10px;\n  outline: none;\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    height: 24px;\n    width: 24px;\n    background: var(--color-primary-500);\n    border: 4px solid var(--color-white-500);\n    border-radius: 50%;\n    cursor: pointer;\n    margin-top: -8px;\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n  }\n\n  &::-moz-range-thumb {\n    height: 24px;\n    width: 24px;\n    background: var(--color-primary-500);\n    border: 4px solid var(--color-white-500);\n    border-radius: 50%;\n    cursor: pointer;\n  }\n\n  &::-webkit-slider-runnable-track {\n    height: 8px;\n    border-radius: 10px;\n  }\n\n\n  &::-moz-range-track {\n    height: 8px;\n    background: var(--color-gray-300);\n    border-radius: 10px;\n  }\n}\n\n.bg-primary {\n  @apply bg-cover bg-center min-h-screen;\n  background-image: var(--background-image) !important;\n}\n\n.recharts-legend-item {\n  margin-left: 36px !important;\n  margin-right: 0px !important;\n}\n\n.lato {\n  font-family: \"Inter\", sans-serif;\n}\n\n.react-datepicker__input-container {\n  input {\n    height: 48px;\n    cursor: pointer;\n  }\n}\n\n.react-datepicker {\n  background-color: var(--color-gray-800) !important;\n  color: var(--color-white-500) !important;\n  border: 1px solid var(--color-primary-400) !important;\n  padding: 8px;\n}\n\n.react-datepicker__header {\n  border: 0 !important;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  background-color: var(--color-gray-800) !important;\n  color: var(--color-white-500) !important;\n}\n\n.react-datepicker__month-text.react-datepicker__month-1.react-datepicker__month-text--selected.react-datepicker__month-text--keyboard-selected.react-datepicker__month-text--today {\n  color: var(--color-white-500) !important;\n}\n\n.react-datepicker__month-text\n  react-datepicker__month-1\n  react-datepicker__month-text--selected\n  react-datepicker__month-text--keyboard-selected\n  react-datepicker__month-text--today {\n  padding: 4px;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  background-color: var(--color-primary-400) !important;\n}\n\n.react-datepicker__triangle {\n  display: none;\n}\n\n* {\n  outline: none;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  text-decoration: none;\n  box-sizing: border-box;\n  font-family: \"Inter\", sans-serif;\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  p {\n    color: var(--color-white-500);\n  }\n\n  &::-webkit-scrollbar {\n    width: 9px;\n    height: 10px;\n    background-color: var(--color-gray-300);\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: var(--color-gray-200);\n    border-radius: 15px;\n  }\n\n  /* Handle on hover */\n  &::-webkit-scrollbar-thumb:hover {\n    background: var(--color-white-500);\n  }\n\n  /* Hide arrow buttons */\n  &::-webkit-scrollbar-button {\n    display: none;\n  }\n\n  /* Hide corner */\n  &::-webkit-scrollbar-corner {\n    background: transparent;\n  }\n}\n\nbody {\n  // font-family: \"Inter\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden !important;\n}\n\nbody,\nhtml {\n  background-color: var(--bg-color);\n}\n\nlabel {\n  color: var(--color-white-500);\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n  background-color: var(--color-gray-800);\n}\n\n::-webkit-scrollbar-track {\n  background: var(--color-gray-800);\n  border-radius: 8px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: var(--color-gray-700);\n  border-radius: 8px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--color-primary-500);\n}\n","@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n","@use \"../colors\" as *;\n// @use \"./typography\" as *;\n\n.breadcumb {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: var(--color-gray-400);\n  a,\n  span {\n    padding: 3px 5px;\n  }\n  a {\n    text-decoration: none;\n    transition: color 0.3s;\n    border-radius: 5px;\n    &:hover {\n      color: var(--color-primary-500);\n      background-color: var(--color-gray-800);\n    }\n  }\n  .divider {\n    color: var(--color-gray-400);\n  }\n}\n","@use \"../colors\" as *;\n@use \"./typography\" as *;\n\n.badge {\n  width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary {\n    background: var(--color-primary-500);\n  }\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: var(--color-yellowdark-500);\n    color: var(--color-yellowlight-300);\n  }\n  &.Unvalidated {\n    background: var(--color-reddark-500);\n    color: var(--color-redlight-300);\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n.badgeTable {\n  width: max-content;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: #413e1a;\n    color: #e6f979;\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n",".table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  &.style-1 {\n    td,\n    th {\n      padding: 12px 1rem;\n      font-size: 0.875rem;\n    }\n    th,\n    td.label {\n      color: var(--color-white-500);\n    }\n    th {\n      font-weight: normal;\n      border-style: solid;\n      border-color: var(--color-gray-100);\n      border-top-width: 1px;\n      border-bottom-width: 1px;\n    }\n    tr {\n      &.noBorder td {\n        border-bottom: none;\n      }\n      td {\n        color: var(--color-white-500);\n        // border-bottom: 1px solid var(--color-paper-400);\n      }\n    }\n  }\n}\n","@use \"../colors\" as *;\n@use \"../flex\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"./typography\" as *;\n\n.pagination {\n    display: inline-flex;\n    height: 38px;\n    // background-color: var(--color-paper-400);\n    border: 1px solid var(--color-gray-700);\n    border-radius: 8px;\n    width: max-content;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none;\n    // @include boxShadow();\n    button {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        &:hover, &.active {\n            @include bgHover(var(--color-paper-400));\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div:last-child, div:first-child {\n        padding: 0 10px;\n    }\n    div:last-child {\n        border-right: none;\n    }\n    button:last-child, button:first-child {\n        padding: 0 10px;\n    }\n    button:last-child {\n        border-right: none;\n    }\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n\n@mixin container($width: 'base', $padding-top: 40) {\n    padding-top: $padding-top+px;\n    padding-bottom: 80px;\n    margin: auto;\n    gap: 40px;\n\n    @if $width == 'base' {\n        // width: $container-width;\n    }\n    @else if $width == 'sm' {\n        width: 712px;\n    }\n    @include tablet {\n        gap: 25px;\n        width: 100%;\n        justify-content: space-between;\n        padding-top: 25px;\n        padding-bottom: 60px;\n        padding-left: 20px !important;\n        padding-right: 20px !important;\n    }\n}\n@mixin bgHover($bg: 'black', $opacity: 90%, $r: 0, $g: 0, $b: 0) {\n    cursor: pointer;\n    background: linear-gradient($bg, rgb($r $g $b / #{$opacity})) top/100% 500%;\n}\n@mixin boxShadow() {\n    -webkit-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    -moz-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"../flex\" as *;\n@use \"./typography\" as *;\n\n.interface {\n  width: 100%;\n  border-radius: 10px;\n  border-left: 2px solid var(--color-gray-800); \n  border-right: 2px solid var(--color-gray-800);\n  background-color: var(--color-gray-100);\n  -webkit-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  -moz-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  @extend %flex-column;\n  &_heading {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 8px 8px 0 0;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n    &_row {\n      @extend %flex-align;\n      justify-content: space-between;\n      width: 100%;\n      gap: 15px;\n      @include mobile {\n        flex-direction: column;\n        align-items: flex-start;\n      } \n    }\n  }\n  &_footer {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 0 0 8px 8px;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n  }\n  &_foot {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    @include mobile {\n      flex-direction: column;\n      align-items: flex-start\n    }\n  }\n  &_noResults {\n    @extend %flex-column-align;\n    gap: 15px;\n    padding: 70px 0;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
